<template>
  <SiteMenuFlyoutLayout :heading="heading" @close="$emit('close')">
    <ul class="text-sm font-semibold uppercase space-y-5">
      <li v-for="(item, itemKey) in items" :key="itemKey">
        <a
          class="inline-flex items-center gap-x-2.5"
          :href="item.link.url"
          :target="item.link.target"
        >
          {{ item.link.text }}
          <div class="w-4"><IconArrowRight /></div>
        </a>
      </li>
    </ul>

    <InlineSvg
      class="h-full w-auto m-auto absolute top-0 left-1/2 -z-10 transform -translate-x-1/2 rotate-16"
      :src="backgroundImage.url"
      :transform-source="removeSvgFill"
      :fill="backgroundImageColour"
    />
  </SiteMenuFlyoutLayout>
</template>

<script>
import InlineSvg from "vue-inline-svg";
import SiteMenuFlyoutLayout from "./SiteMenuFlyoutLayout.vue";
import IconArrowRight from "../../../templates/_includes/svg/icon-arrow-right.svg";
import { removeSvgFill } from "../../js/utils";

export default {
  name: "SiteMenuFlyoutMegaSecondarySub",

  components: {
    InlineSvg,
    SiteMenuFlyoutLayout,
    IconArrowRight,
  },

  props: {
    backgroundImage: {
      type: Object,
      default: null,
    },
    backgroundImageColour: {
      type: String,
      default: null,
    },
    heading: {
      type: String,
      default: null,
    },
    items: {
      type: Array,
      required: true,
    },
  },

  methods: {
    removeSvgFill,
  },
};
</script>
